export * from './regex'
export * from './swrKey'

export const DEFAULT_LIMIT = 20
export const HEADER_HEIGHT = 100
